export default __webpack_public_path__ + "static/center-fr-75357dc7652c3def339f1ea9b1a4895a.webp";